<h1 class="title">BIM Data</h1>
<h5>Prepare BIM data for external sharing</h5>
<div class="cas-wrapper">
    <acabim-admin-view-export-requests #viewModel></acabim-admin-view-export-requests>
    <acabim-admin-create-export-request (dataExportRequestCreated)="viewModel.onNewRequestCreated($event)"></acabim-admin-create-export-request>
</div>
